module.exports = __webpack_public_path__ + "img/BJYX_Android.15758a33.png";